import React from 'react'
import PropTypes from 'prop-types'

import { Card } from 'semantic-ui-react'

const FACardGroup = ({ children }) => (
  <Card.Group itemsPerRow={5} stackable>
    {children}
  </Card.Group>
)

FACardGroup.propTypes = {
  children: PropTypes.node.isRequired,
}

export default FACardGroup
